export default () => {
    const textElement = document.querySelector('.wp-perf__nav-toggle--sticky-logo .wp-block-heading');
    const colorPalette = [ '#FC2678', '#6E3FFC', '#AFFD32', '#2A8AFA', '#FFF8EB'];
    let currentIndex = 0;

    function changeColor() {
        textElement.style.color = colorPalette[currentIndex];
        currentIndex = (currentIndex + 1) % colorPalette.length;
    }

    let hoverInterval;

    textElement.addEventListener('mouseenter', () => {
        hoverInterval = setInterval(changeColor, 1000);
    });

    textElement.addEventListener('mouseleave', () => {
        clearInterval(hoverInterval);
        textElement.style.color = colorPalette[0];
    });
}